<div class="dialog">
  <span class="dialog-close" (click)="close()">
    <i class="fa fa-close"></i>
  </span>
  <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
  <div class="dialog-content">
    <span class="loading-spiner" *ngIf="!season"></span>

    <form [formGroup]="form" class="form-horizontal" autocomplete="off" novalidate *ngIf="season">
      <app-translation-content-title [language]="language"></app-translation-content-title>

      <!-- Name -->
      <div class="form-group">
        <label class="col-md-3 control-label">
          <span class="required">*</span> {{ 'NAME' | translate }}
        </label>
        <div class="col-md-9">
          <input type="text" class="form-control" formControlName="name" maxlength="100" />
          <app-form-errors [control]="form.controls['name']"></app-form-errors>
          <app-form-server-errors [error]="serverErrors['name']"></app-form-server-errors>
        </div>
      </div>

      <div class="form-actions no-wrap">
        <app-item-detail-form-actions
          [disableSaveItem]="sendingForm"
          [updateItemLabel]="'SAVE_CHANGES'"
          [sendingForm]="sendingForm"
          (canceled)="onCanceled()"
          (saved)="onSavedSeasonTranslation()"
        ></app-item-detail-form-actions>
      </div>
    </form>
  </div>
</div>
